import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twozeroseaterbushireinpune() {



const cardData =
{
  keyword: '20 Seater Bus Hire in Pune',
  heading: 'Sanavi Travels: 20 Seater Bus Hire in Pune',
  headingDescription: 'Sanavi Travels offers reliable and comfortable 20 Seater Bus Hire in Pune for families, corporate groups, weddings, picnics, and outstation travel. Our well-maintained AC and Non-AC 20 seater buses with experienced drivers ensure smooth group transportation across Pune and nearby destinations.',

  top: 'Best Uses of 20 Seater Bus Hire in Pune',

  topPlaces: [
    {
      title: 'Family Group Travel in Pune',
      description: '20 seater buses are ideal for family group travel within Pune and nearby locations. Families can travel together comfortably without splitting into multiple vehicles, making outings, functions, and religious visits more convenient and well-coordinated.'
    },
    {
      title: 'Corporate Group Transportation',
      description: 'Corporate teams often require safe and punctual transport for meetings, training programs, conferences, and off-site events. A 20 seater bus offers the perfect balance of seating capacity and comfort, ensuring employees travel together efficiently.'
    },
    {
      title: 'Wedding Guest Transportation',
      description: 'Wedding events require organized movement of guests between venues. Hiring a 20 seater bus helps manage guest transportation smoothly, avoids parking issues, and keeps everyone on schedule during wedding functions.'
    },
    {
      title: 'Picnic & One-Day Trips',
      description: 'For picnics and one-day outings around Pune, a 20 seater bus provides ample space, comfort, and safety. Groups can enjoy the journey together, making the trip as enjoyable as the destination.'
    },
    {
      title: 'Outstation & Tour Travel',
      description: 'Outstation tours from Pune to nearby tourist destinations are more relaxed with a 20 seater bus. Spacious seating, luggage space, and experienced drivers make long-distance group travel stress-free.'
    }
  ],

  services: [
    {
      name: '20 Seater Bus Hire in Pune',
      description: 'Sanavi Travels provides professional 20 seater bus hire services in Pune suitable for family trips, corporate travel, weddings, picnics, and tours. Our buses are clean, comfortable, and driven by experienced drivers, ensuring safe and pleasant group journeys.'
    },
    {
      name: 'AC 20 Seater Bus Pune',
      description: 'AC 20 seater buses are perfect for comfortable travel during summer and long-distance journeys. Air-conditioned interiors help passengers remain relaxed and refreshed throughout the trip.'
    },
    {
      name: 'Non AC 20 Seater Bus Hire Pune',
      description: 'Non-AC 20 seater buses offer an economical option for short-distance and budget-conscious group travel while still maintaining comfort and safety standards.'
    },
    {
      name: 'Luxury 20 Seater Bus Hire Pune',
      description: 'Luxury 20 seater buses feature premium seating, better interiors, and smooth ride quality, making them suitable for VIP guests, weddings, and corporate events.'
    },
    {
      name: '20 Seater Bus for Family Pune',
      description: 'Family-focused 20 seater bus services allow all members to travel together conveniently, ensuring a comfortable and well-managed group journey.'
    },
    {
      name: '20 Seater Bus for Corporate Pune',
      description: 'Corporate 20 seater bus hire supports office commutes, team outings, training sessions, and corporate events with punctual and professional transport.'
    },
    {
      name: '20 Seater Bus for Group Pune',
      description: 'Group travel becomes easier with a 20 seater bus as it ensures coordinated movement, better communication, and shared travel experience.'
    },
    {
      name: 'Affordable 20 Seater Bus Hire Pune',
      description: 'Sanavi Travels offers competitively priced 20 seater bus rental packages that suit different budgets without compromising on service quality.'
    },
    {
      name: 'Best 20 Seater Bus Service Pune',
      description: 'Known for reliability and customer satisfaction, Sanavi Travels is trusted for providing the best 20 seater bus services across Pune.'
    },
    {
      name: '20 Seater Bus with Driver Pune',
      description: 'All 20 seater buses come with skilled and experienced drivers familiar with Pune routes and highways, ensuring safety and timely travel.'
    },
    {
      name: '20 Seater Bus for Wedding Pune',
      description: 'Wedding transportation becomes smooth and organized with 20 seater buses that handle guest transfers efficiently between venues.'
    },
    {
      name: '20 Seater Bus for Picnic Pune',
      description: 'For school, office, or family picnics, a 20 seater bus offers comfortable seating and enough space for a relaxed group journey.'
    },
    {
      name: '20 Seater Bus for Tour Pune',
      description: 'Tour groups benefit from the comfort and capacity of 20 seater buses, making sightseeing trips enjoyable and well-planned.'
    },
    {
      name: '20 Seater Bus for Outstation Pune',
      description: 'Outstation travel with a 20 seater bus ensures smooth long-distance journeys with adequate space, comfort, and safety.'
    }
  ],

  tableData: [
    ['20 Seater Bus Pune', 'AC 20 Seater Bus'],
    ['Non AC 20 Seater Bus', 'Luxury 20 Seater Bus'],
    ['Family Travel', 'Corporate Travel'],
    ['Wedding Transport', 'Picnic Trips'],
    ['Outstation Tours', 'Group Travel']
  ],

  whychoose: [
    { WhyChooseheading: 'Comfortable Seating', WhyChoosedescription: 'Spacious and comfortable seating for group travel.' },
    { WhyChooseheading: 'Experienced Drivers', WhyChoosedescription: 'Professional drivers with local route knowledge.' },
    { WhyChooseheading: 'Well-Maintained Buses', WhyChoosedescription: 'Clean and regularly serviced vehicles.' },
    { WhyChooseheading: 'Flexible Usage', WhyChoosedescription: 'Suitable for weddings, corporate, picnics, and tours.' },
    { WhyChooseheading: 'Affordable Pricing', WhyChoosedescription: 'Competitive rates with transparent pricing.' }
  ]
};

const faqData = [
  { question: 'Do you provide 20 seater bus hire in Pune?', answer: 'Yes, Sanavi Travels offers 20 seater bus hire services across Pune.' },
  { question: 'Are AC 20 seater buses available?', answer: 'Yes, both AC and Non-AC options are available.' },
  { question: 'Is a driver included with the bus?', answer: 'Yes, all buses come with experienced drivers.' },
  { question: 'Can I hire a 20 seater bus for weddings?', answer: 'Yes, wedding transportation is one of our main services.' },
  { question: 'Is the bus suitable for corporate travel?', answer: 'Yes, 20 seater buses are ideal for corporate groups.' },
  { question: 'Do you offer outstation trips?', answer: 'Yes, outstation travel is available.' },
  { question: 'Are the buses well maintained?', answer: 'Yes, all buses are regularly cleaned and serviced.' },
  { question: 'Can the bus be used for picnics?', answer: 'Yes, picnic and one-day trips are supported.' },
  { question: 'How can I book a 20 seater bus?', answer: 'You can contact Sanavi Travels directly to book.' },
  { question: 'Do you offer affordable packages?', answer: 'Yes, we provide competitive and transparent pricing.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Rahul Mehta',
    feedback: 'Booked a 20 seater bus for family trip in Pune. Very comfortable and smooth service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Neha Kulkarni',
    feedback: 'Excellent bus service for our corporate outing. Highly recommended.',
    rating: 5
  }
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "20 Seater Bus Hire in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers 20-seater buses on hire in Pune for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours. AC and Non-AC 20-seater buses and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 20 Seater Bus Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 20-seater buses for hire in Pune with Sanavi Travels. AC & Non-AC 20-seater buses and mini buses for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/276.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twozeroseaterbushireinpune;